import React, { useRef, useState } from 'react';
import debounce from 'debounce';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import CourtPicker from './CourtPicker';
import PaymentPicker from './PaymentPicker';

const FinanceDetails = ({ timesheet, organization = {}, tariff, referrer, items, onChange }) => {
    const [costCentre, setCostCentre] = useState(timesheet.court?.costCentre);
    const poRef = useRef();
    const caseNumberRef = useRef();

    const handleChange = debounce(() => {
        timesheet.purchaseOrder = poRef.current.value || '';
        timesheet.courtCaseNumber = caseNumberRef.current.value || '';
        onChange();
    }, 500);

    const handleCourtChange = court => {
        setCostCentre(court?.costCentre);
        timesheet.court = court;
        onChange();
    }

    const handleInvoiceeChange = invoicee => {
        console.log('handleInvoiceeChange', invoicee)
        timesheet.invoicee = invoicee;
        onChange();
    }

    return (
        <Paper style={{ padding: '1rem', marginBottom: '1rem' }}>
            <Typography variant="h6" color="initial" >Finance Details</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3} lg={2}>
                    <TextField
                        inputRef={poRef}
                        onChange={handleChange}
                        fullWidth
                        defaultValue={timesheet.purchaseOrder || ''}
                        label="PO Number"
                        helperText=""
                    />
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                    <CourtPicker onChange={handleCourtChange} court={timesheet.court} />
                </Grid>
                <Grid item xs={12} md={3} lg={2}>
                    <TextField
                        disabled
                        value={costCentre || ''}
                        label="Cost Code"
                        helperText=""
                    />
                </Grid>
                <Grid item xs={12} md={3} lg={2}>
                    <TextField
                        inputRef={caseNumberRef}
                        onChange={handleChange}
                        fullWidth
                        defaultValue={timesheet.courtCaseNumber || ''}
                        label="Court Case Number"
                        helperText=""
                        required
                    />
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                    <PaymentPicker
                        onChange={handleInvoiceeChange}
                        referrer={referrer}
                        organization={organization}
                        tariff={tariff}
                        items={items}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default FinanceDetails;